import { render, staticRenderFns } from "./UserUpdateDialog.vue?vue&type=template&id=2dbfccec&scoped=true"
import script from "./UserUpdateDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserUpdateDialog.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dbfccec",
  null
  
)

export default component.exports